// !!! This file is automatically generated by command [npm run dc-sdk] !!!
// !!! please do not change manually !!! 
function dcInit() { return true };
var CHECK_TYPE="type";
var CHECK_MANDATORY="mandatory";
var CHECK_CLIENT_MANDATORY="clientmandatory";
var CHECK_RANGE="range";
var POINT_TYPE="_ac_type";
var POINT_APPID="_uniq_key";
var POINT_GID="_user_id";
var EXTRACT_MAP="extractmap";
var ILLEGAL_CHARACTER_ARR = ["\"",",","'","\\","\n","\\001","\r","\f", "\\002","\\003",":","[","]","{","}","&","?","%","#","|"];
var ILLEGAL_CHARACTER = "\",'\\n\\001\\f\\002\\003:&?%#[]{}\\|";
var ILLEGAL_CHARACTER_EXTRACT_MAP_ARR = ["'","\\","\n","\\001","\r","\f", "\\002","\\003","[","]","&","?","%","#","|"];
var ILLEGAL_CHARACTER_EXTRACT_MAP = "'\\n\\001\\f\\002\\003&?%#[]\\|";
var SCHEMA_CLENT_VERSION_KEY="_schema_cver";
var SCHEMA_CLENT_VERSION_VALUE="10";


//处理IE map未定义问题
var isIE = !(typeof(Map)==='function' && Map.toString().indexOf('[native code]')>-1);

if(isIE){
    function Map() {
        this.elements = new Array();
        // 获取Map元素个数
        this.size = function() {
            return this.elements.length;
        },
		// 判断Map是否为空
		this.isEmpty = function() {
			return (this.elements.length < 1);
		},
		// 删除Map所有元素
		this.clear = function() {
			this.elements = new Array();
		},
		// 向Map中增加元素（key, value)
		this.put = function(_key, _value) {
			if (this.containsKey(_key) == true) {
				if (this.containsValue(_value)) {
					if (this.remove(_key) == true) {
						this.elements.push({
							key : _key,
							value : _value
						});
					}
				} else {
					this.elements.push({
						key : _key,
						value : _value
					});
				}
			} else {
				this.elements.push({
					key : _key,
					value : _value
				});
			}
		},
		// 向Map中增加元素（key, value)
		this.set = function(_key, _value) {
			if (this.containsKey(_key) == true) {
				if (this.containsValue(_value)) {
					if (this.remove(_key) == true) {
						this.elements.push({
							key : _key,
							value : _value
						});
					}
				} else {
					this.elements.push({
						key : _key,
						value : _value
					});
				}
			} else {
				this.elements.push({
					key : _key,
					value : _value
				});
			}
		},
		// 删除指定key的元素，成功返回true，失败返回false
		this.remove = function(_key) {
			var bln = false;
			try {
				for (i = 0; i < this.elements.length; i++) {
					if (this.elements[i].key == _key) {
						this.elements.splice(i, 1);
						return true;
					}
				}
			} catch (e) {
				bln = false;
			}
			return bln;
		},
		// 获取指定key的元素值value，失败返回null
		this.get = function(_key) {
			try {
				for (i = 0; i < this.elements.length; i++) {
					if (this.elements[i].key == _key) {
						return this.elements[i].value;
					}
				}
			} catch (e) {
				return null;
			}
		},
		// set指定key的元素值value
		this.setValue = function(_key, _value) {
			var bln = false;
			try {
				for (i = 0; i < this.elements.length; i++) {
					if (this.elements[i].key == _key) {
						this.elements[i].value = _value;
						return true;
					}
				}
			} catch (e) {
				bln = false;
			}
			return bln;
		},
		// 获取指定索引的元素（使用element.key，element.value获取key和value），失败返回null
		this.element = function(_index) {
			if (_index < 0 || _index >= this.elements.length) {
				return null;
			}
			return this.elements[_index];
		},
		// 判断Map中是否含有指定key的元素
		this.containsKey = function(_key) {
			var bln = false;
			try {
				for (i = 0; i < this.elements.length; i++) {
					if (this.elements[i].key == _key) {
						bln = true;
					}
				}
			} catch (e) {
				bln = false;
			}
			return bln;
		},
		// 判断Map中是否含有指定key的元素
		this.has = function(_key) {
			var bln = false;
			try {
				for (i = 0; i < this.elements.length; i++) {
					if (this.elements[i].key == _key) {
						bln = true;
					}
				}
			} catch (e) {
				bln = false;
			}
			return bln;
		},
		// 判断Map中是否含有指定value的元素
		this.containsValue = function(_value) {
			var bln = false;
			try {
				for (i = 0; i < this.elements.length; i++) {
					if (this.elements[i].value == _value) {
						bln = true;
					}
				}
			} catch (e) {
				bln = false;
			}
			return bln;
		},
		// 获取Map中所有key的数组（array）
		this.keys = function() {
			var arr = new Array();
			for (i = 0; i < this.elements.length; i++) {
				arr.push(this.elements[i].key);
			}
			return arr;
		},
		// 获取Map中所有value的数组（array）
		this.values = function() {
			var arr = new Array();
			for (i = 0; i < this.elements.length; i++) {
				arr.push(this.elements[i].value);
			}
			return arr;
		};
        /**
         * map遍历数组
         * @param callback [function] 回调函数；
         * @param context [object] 上下文；
         */
        this.forEach = function forEach(callback,context){
            context = context || window;
            //IE6-8下自己编写回调函数执行的逻辑
            var newAry = new Array();
            for(var i = 0; i < this.elements.length;i++) {
                if(typeof  callback === 'function') {
                    var val = callback.call(context,this.elements[i].value,this.elements[i].key,this.elements);
                    newAry.push(this.elements[i].value);
                }
            }
            return newAry;
        }
    }
    exports.Map = Map
}



//初始化的map
//old atrr 和 new attr对应关系
var ATTR_OLD_NEW_MAP = new Map();
ATTR_OLD_NEW_MAP.set("server","keyword_server");
ATTR_OLD_NEW_MAP.set("data","keyword_data");
ATTR_OLD_NEW_MAP.set("use","keyword_use");
ATTR_OLD_NEW_MAP.set("guideId","guideid");
ATTR_OLD_NEW_MAP.set("clientDetail","clientdetail");
ATTR_OLD_NEW_MAP.set("clientVersion","clientversion");
ATTR_OLD_NEW_MAP.set("textId","textid");
ATTR_OLD_NEW_MAP.set("yellowStar","yellowstar");
ATTR_OLD_NEW_MAP.set("partition","keyword_partition");
ATTR_OLD_NEW_MAP.set("levelId","levelid");
ATTR_OLD_NEW_MAP.set("enemyProgress","enemyprogress");
ATTR_OLD_NEW_MAP.set("from","keyword_from");
ATTR_OLD_NEW_MAP.set("isUseSmallRes","isusesmallres");
ATTR_OLD_NEW_MAP.set("T1","t1");
ATTR_OLD_NEW_MAP.set("T2","t2");
ATTR_OLD_NEW_MAP.set("T3","t3");
ATTR_OLD_NEW_MAP.set("wxScene","wxscene");
ATTR_OLD_NEW_MAP.set("level","keyword_level");
ATTR_OLD_NEW_MAP.set("frameId","frameid");
ATTR_OLD_NEW_MAP.set("index","keyword_index");
ATTR_OLD_NEW_MAP.set("orangeStar","orangestar");
ATTR_OLD_NEW_MAP.set("IMEI","imei");
ATTR_OLD_NEW_MAP.set("updateTime","updatetime");
ATTR_OLD_NEW_MAP.set("currentLevel","currentlevel");
ATTR_OLD_NEW_MAP.set("0","gacha_item1");
ATTR_OLD_NEW_MAP.set("srcChannel","src_channel");
ATTR_OLD_NEW_MAP.set("1","gacha_item2");
ATTR_OLD_NEW_MAP.set("2","gacha_item3");
ATTR_OLD_NEW_MAP.set("myProcess","myprocess");
ATTR_OLD_NEW_MAP.set("errCode","errcode");
ATTR_OLD_NEW_MAP.set("appid","client_appid");
ATTR_OLD_NEW_MAP.set("location","keyword_location");
ATTR_OLD_NEW_MAP.set("sdkVersion","sdkversion");
ATTR_OLD_NEW_MAP.set("interval","keyword_interval");
ATTR_OLD_NEW_MAP.set("time","client_time");
ATTR_OLD_NEW_MAP.set("detail","keyword_detail");
ATTR_OLD_NEW_MAP.set("isGroup","isgroup");
ATTR_OLD_NEW_MAP.set("blueStar","bluestar");
ATTR_OLD_NEW_MAP.set("t1","t1");
var ATTR_OLD_NEW_MAP_SIZE=39;

//old table 和 new table 对应关系
var ACTYPE_OLD_NEW_MAP = new Map();
ACTYPE_OLD_NEW_MAP.set("9","data_9");
var ACTYPE_OLD_NEW_MAP_SIZE = 1;

var schemaMap = new Map();
var COLCHECK_STRINGTRUE_CMTRUE = new Map([["type","string"], ["mandatory","true"], ["clientmandatory","true"]]);
var COLCHECK_STRINGTRUE_CMFALSE = new Map([["type","string"], ["mandatory","true"], ["clientmandatory","false"]]);
var COLCHECK_STRINGFALSE_CMTRUE = new Map([["type","string"], ["mandatory","false"], ["clientmandatory","true"]]);
var COLCHECK_STRINGFALSE_CMFALSE = new Map([["type","string"], ["mandatory","false"], ["clientmandatory","false"]]);
/*工具类 开始*/

// 获取SCHEMA_CLENT_VERSION_VALUE
function getSchemaClentVersionValue(){
    return SCHEMA_CLENT_VERSION_VALUE
}

exports.getSchemaClentVersionValue = getSchemaClentVersionValue

/**
 * 根据老的字段名 获取新字段名 如果没有就原值返回
 * @param oldAttr  老的字段名称
 * @return
 */
function getNewAttr(oldAttr){
    if(typeof(oldAttr)=="undefined" || oldAttr===null){
        return oldAttr;
    }
    if(ATTR_OLD_NEW_MAP_SIZE==0){
        return oldAttr;
    }
    if(ATTR_OLD_NEW_MAP.has(oldAttr)){
        return ATTR_OLD_NEW_MAP.get(oldAttr);
    }else{
        return oldAttr;
    }
}

exports.getNewAttr = getNewAttr

/**
 * 根据旧的点号返回新的点号  不包括101
 * @param oldAcType  老的点号
 * @return
 */
function getNewAcType(oldAcType){
    if(typeof(oldAcType)=="undefined" || oldAcType===null){
        return oldAcType;
    }
    if(ACTYPE_OLD_NEW_MAP_SIZE==0){
        return oldAcType;
    }
    if(ACTYPE_OLD_NEW_MAP.has(oldAcType)){
        return ACTYPE_OLD_NEW_MAP.get(oldAcType);
    }else{
        return oldAcType;
    }
}

exports.getNewAcType = getNewAcType

/**
 * 目前为拆分101表使用，根据点号和category 返回新的调号
 * 如果没有category的mapping  返回useraction_unknown_category
 * @param oldAcType 老的点号
 * @param category  老的category
 * @return
 */
function getNewAcTypeSplit(oldAcType,category){
    if(typeof(oldAcType)=="undefined" || oldAcType===null){
        return null;
    }
    if(ACTYPE_OLD_NEW_MAP_SIZE==0){
        return category;
    }
    if(typeof(category)=="undefined" || category===null){
        return ACTYPE_OLD_NEW_MAP.get(oldAcType+"_*");
    }
    var key = oldAcType+"_"+category;
    if(ACTYPE_OLD_NEW_MAP.has(key)){
        return ACTYPE_OLD_NEW_MAP.get(key);
    }else {
        return ACTYPE_OLD_NEW_MAP.get(oldAcType+"_*");
    }
}

/**
 * 判断一个点号的 属性是否在schema中 方便生成最后的extractMap
 * @param newActype
 * @param newAttr
 * @return
 */
function isExistInSchema(newActype,newAttr){
    var result = false;
    if( (typeof(newActype)=="undefined" || newActype===null) || (typeof(newAttr)=="undefined" || newAttr===null)){
        return result;
    }

    if(schemaMap.has(newActype)){
        if(newAttr==POINT_TYPE || newAttr==POINT_APPID || newAttr==POINT_GID){
            result = true;
        }else{
            result = (schemaMap.get(newActype)).has(newAttr);
        }
    }
    return result;
}
/*工具类 结束*/
function PackageResponse(success,errorReason){
  this.success = success;
  this.errorReason = errorReason;
}
//var tt = new PackageResponse("false","tttttt");
//console.log(tt.success)
/**
 * js 调用入口 主函数
 */
function checkRequest(logMap,extractMap) {
    if(!__DEBUG){
        logMap.set(SCHEMA_CLENT_VERSION_KEY, SCHEMA_CLENT_VERSION_VALUE);
        return { success: true };
    }
    if(!dcInit()){
        console.warn("dc not init yet. checkRequest will always return true");
        logMap.set(SCHEMA_CLENT_VERSION_KEY, SCHEMA_CLENT_VERSION_VALUE);
        return { success: true };
    }

    var p = getRequestStr(logMap);
    if(logMap.has(EXTRACT_MAP) && (typeof(extractMap)=="undefined" || extractMap===null)){
        p.success = false;
        p.errorReason = "if log map contain "+EXTRACT_MAP+", param extractMap must is not null";
        return p;
    }
    if(p.success) {
        // 可以没有extractMap
        if((typeof(extractMap)!="undefined" && extractMap !=null) ) {
            // if()
            var extractMapSize;
            if(isIE){
                extractMapSize = extractMap.keys().length;
            }else{
                extractMapSize = extractMap.size;
            }
            if(extractMapSize >= 200){
                p.success = false;
                p.errorReason = "kv size in extractMap need less than 200";
            }
         }
    }
    return p;
}

exports.checkRequest = checkRequest

/**
 * 核心函数
 * @param logMap
 * @returns {*}
 */
function getRequestStr(logMap){
    var result = new PackageResponse(false,'');
    if(typeof(logMap)=="undefined" || logMap===null || logMap.size==0){
        result.errorReason= "log map is null or empty";
        return result;
    }
    //0  判断type、appid、gid是否在日志记录汇总 因为type、appid、gid没有在schema中定义，所以此处硬编码
    //刘晓杰(刘晓杰) 那是用户上传的、下发给采集的、下发给下载的所有xml，都不加gid/appid/payload/type/server_time吗？确定以下
    //凌聪(凌聪) 15:59  是的
    //判断日志中是否包含点号
    if(!logMap.has(POINT_TYPE)){
        result.errorReason= "point must has col "+POINT_TYPE;
        return result;
    }
    var point = logMap.get(POINT_TYPE)
    //判断点号是否在schema中
    if(!schemaMap.has(point)){
        result.errorReason= "point "+point+" not in schema";
        return result;
    }
    if(!logMap.has(POINT_APPID)){
        result.errorReason= "point must has col "+POINT_APPID;
        return result;
    }
    if(!logMap.has(POINT_GID) && point!=="user_load" && point!=="game_install"){
        result.errorReason= "point must has col "+POINT_GID;
        return result;
    }
    //1 判断字段个数是否匹配
    var pointMap = schemaMap.get(point);
    if((pointMap.size+3)<logMap.size){
        result.errorReason= "log map size more than schema column size";
        return result;
    }
    //2 判断必传字段
    var pointMapKeys;
    if(isIE){
        pointMapKeys = pointMap.keys();
    }else{
        pointMapKeys = Array.from(pointMap.keys());
	}
    var pointMapKeysLength = pointMapKeys.length;
    for (var j = 0; j < pointMapKeysLength; j++) {
        var col = pointMapKeys[j];
        var colCheckMap = pointMap.get(col);
        //服务器端必传
        if(typeof(colCheckMap)!="undefined" && "true"==colCheckMap.get(CHECK_MANDATORY) && !logMap.has(col)){
            //不包含这个字段 但是这个字段是必传字段
            result.errorReason= "point must has col "+col;
            return result;
        }
        //客户端必传
        if(typeof(colCheckMap)!="undefined" && "true"==colCheckMap.get(CHECK_CLIENT_MANDATORY) && !logMap.has(col)){
            //不包含这个字段 但是这个字段是必传字段
            result.errorReason= "point must has col "+col;
            return result;
        }
    }
    //3 类型和range校验
    var logMapKeys;
    if(isIE){
        logMapKeys = logMap.keys();
	}else{
        logMapKeys = Array.from(logMap.keys());
	}
    var logMapKeysLength = logMapKeys.length;
    for (var i = 0; i < logMapKeysLength; i++){
        var col = logMapKeys[i];
        var logColValue = logMap.get(col);
        //0.0 这三个字段不做检查 因为没有在schema中
        if(col==POINT_TYPE || col==POINT_APPID || col==POINT_GID){
            var illegalCharacter = checkLogValue(logColValue);
            if(typeof(illegalCharacter)!="undefined" && illegalCharacter!==null){
                result.errorReason="col "+col+" value is "+logColValue+"include illegal character "+illegalCharacter+", illegal character set is "+ILLEGAL_CHARACTER;
                return result;
            } else {
                continue;
            }
        }
        //0.1 判断字段是否在schema中
        if(!pointMap.has(col)){
            //不包含这个字段 则返回异常
            result.errorReason= "col "+col+" not in point";
            return result;
        }
        //1.1 extractmap字段直接透传 不做类型和range校验
        if(col==EXTRACT_MAP){
            var illegalCharacter = checkLogValueExtractMap(logColValue);
            if(typeof(illegalCharacter)!="undefined" && illegalCharacter!==null){
                result.errorReason= "col "+col+"  value is "+logColValue+" include illegal character "+illegalCharacter+", illegal character set is "+ILLEGAL_CHARACTER_EXTRACT_MAP;
                return result;
            } else {
                continue;
            }
        }
        //1.2 检查value是否包含特殊字符
        var illegalCharacter = checkLogValue(logColValue);
        if(null!=illegalCharacter){
            result.errorReason= "col "+col+"  value is "+logColValue+" include illegal character "+illegalCharacter+", illegal character set is "+ILLEGAL_CHARACTER;
            return result;
        }
        //2.0 获取字段 检验类型,range
        var colCheckMap = pointMap.get(col);
        if(colCheckMap.has(CHECK_TYPE)){
            //类型检查
            var schemaColType = colCheckMap.get(CHECK_TYPE);
            if(!checkColType(schemaColType,logColValue)){
                result.errorReason= "point "+point+"'s col "+col+" type must is "+schemaColType;
                return result;
            }
        }
        if(colCheckMap.has(CHECK_RANGE)){
            //range检查
            var range = colCheckMap.get(CHECK_RANGE);
            var type = colCheckMap.get(CHECK_TYPE);
            if(!checkColRange(range,logColValue,type)){
                result.errorReason= "point "+point+"'s col "+col+" range is "+range+",but log's value is "+logColValue;
                return result;
            }
        }

    }
    logMap.set(SCHEMA_CLENT_VERSION_KEY,SCHEMA_CLENT_VERSION_VALUE);
    result.success = true;
    return result;
}

/**
 * 检查 logmap传入的value
 * @param logValue
 * @returns {*}
 */
function checkLogValue(logValue){
    var result = null;
    return result;
}

/**
 * 检查 extractmap传入的value值
 * @param logValue
 * @return
 */
function checkLogValueExtractMap(logValue){
    var result = null;
    return result;
}

/**
 * 检查类型
 * @param type1
 * @param colValue
 * @returns {boolean}
 */
function checkColType(type1,colValue){
    var flag = false;
    if(typeof(type1)=="undefined" || type1===null){
        return flag;
    }
    if(type1=="string"){
        flag = true;
    }else if(type1=="int" || type1=="double"){
        if(typeof colValue !== 'number'){
            flag = false;
        }
        if(!isNaN(colValue)){
            flag =  true;
        }else{
            flag = false;
        }
    }else if(type1=="bool"){
        if(typeof colValue == "boolean" || "true"==colValue || "false"==colValue){
            flag = true;
        } else {
            flag = false;
        }
    }else if(type1=="datetime"){
        if(isNaN(colValue)&&!isNaN(Date.parse(colValue))){
            flag = true;
        }
    }
    return flag;
}

/**
 * 检查范围
 * @param range
 * @param colValue
 * @param type1
 * @returns {boolean}
 */
function checkColRange(range,colValue,type1){
    var flag = false;
    var numstart = 0;
    var numend = 0;
    if(range.indexOf("-") == -1){
        return false;
    }
    var arrTab = range.split("-");
    numstart = arrTab[1];
    numend = arrTab[2];
    if(colValue>=numstart && colValue <= numend){
        flag = true;
    }
    return flag;
}

if(!isIE){
	exports.Map = Map
}

var DC_RES_NAME="10-1730195861082"
/**
 * dc-sdk初始化
 * 如果拆分出资源，strip脚本会将这个文件拼接在导出的sdk文件末尾
 */
if (__DEBUG) {
    let _init = false;

    dcInit = function() {
        return _init;
    }
    function init(config) {
        if (_init)
            return;
        if (config.ver != DC_RES_NAME) {
            console.error("dc.json版本号与sdk中的不符，请检查！");
        }

        // 处理ATTR_OLD_NEW_MAP
        //initAttrOldNewMap(config);

        // 处理ACTYPE_OLD_NEW_MAP_SIZE
        //initActypeOldNewMap(config);

        // 处理schemaMap
        initSchemaMap(config);

        _init = true;
    }

    function initAttrOldNewMap(config) {
        let ary = config.attrOldNewMap;
        let count = 0;

        ary.forEach(item=> {
            ATTR_OLD_NEW_MAP.set(item.k, item.v);
            count++;
        });
        ATTR_OLD_NEW_MAP_SIZE = count;
    }

    function initActypeOldNewMap(config) {
        let ary = config.actypeOldNewMap;
        let count = 0;
        ary.forEach(item=> {
            ACTYPE_OLD_NEW_MAP.set(item.k, item.v);
            count++;
        });
        ACTYPE_OLD_NEW_MAP_SIZE = count;
    }

    let _colCheckAry = [
        COLCHECK_STRINGTRUE_CMTRUE,
        COLCHECK_STRINGTRUE_CMFALSE,
        COLCHECK_STRINGFALSE_CMTRUE,
        COLCHECK_STRINGFALSE_CMFALSE
    ];


    function initSchemaMap(config) {    
        let ary = config.schemaMap;
        ary.forEach(item=> schemaMap.set(item.k, buildMap(item.map, item.extra)));
    }

    function buildExtraMap(mapConfig) {
        let map = new Map();
        mapConfig.forEach(item=> map.set(item.k, item.v));
        return map;
    }

    function buildMap(mapConfig, extraMapConfig) {
        let map = new Map();
        mapConfig.forEach(item=> {
            if (_colCheckAry[item.v]) {
                map.set(item.k, _colCheckAry[item.v])
            } else if(item.k == "extractmap") {
                map.set(item.k, buildExtraMap(extraMapConfig));
            }
        });
        return map;
    }

    exports.init = init
    
    // load dc-res
    var xhr = new XMLHttpRequest();
    xhr.open('GET', DC_RES_URL + `dc.${DC_RES_NAME}.json?t=${(new Date()).getTime()}`);
    xhr.onload = ()=> {
        if (xhr.status == 200) {
            try{
                let config = JSON.parse(xhr.response);
                init(config);
            }catch(e){                
                console.error("parse dc-res failed!", xhr.response, e)
            }
        } else {
            console.error("load dc-res failed!", xhr.status, xhr.statusText)
        }
    } 
    xhr.onerror = ()=> console.error("load dc-res failed!", xhr.status, xhr.statusText);
    xhr.send();
}

